
import React, { useState, useRef, useEffect } from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Map from '../../assets/mics/image.png'

function ZoomPanPinch() {

    const [imgWidth, setImgWidth] = useState(null);
    const [imgHeight, setImgHeight] = useState(null);
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const [downX, setDownX] = useState(0);
    const [downY, setDownY] = useState(0);
    var [newDownX] = useState(0);
    var [newDownY] = useState(0);
    const [scalingFactor, setScalingFactor] = useState(1);
    const [viewBriefToggle, setViewBriefToggle] = useState(true);
    var [groundValueX, setGroundValueX] = useState(0);
    var [groundValueY, setGroundValueY] = useState(0);
    var [positionValueX, setPositionValueX] = useState(0);
    var [positionValueY, setPositionValueY] = useState(0);
    var [originalX, setOriginalX] = useState(null);
    var [originalY, setOriginalY] = useState(null);
    var [flag, setFlag] = useState(false);

    //DOCS: https://stackoverflow.com/questions/61864491/reactjs-get-height-of-a-div-image-using-react-hooks
    const ref = useRef()
    const counterRef = useRef(0); // Just to count loops

    useEffect(() => {
        let cancelled = false;
        const getHeightAndWidth = () => {
            ++counterRef.current;
            const { current } = ref; // `ref` will never be falsy
            if (!current || !current.clientHeight || !current.clientWidth) {
                if (!cancelled) {
                    requestAnimationFrame(getHeightAndWidth);
                }
            } else {
                // Use `current.clientHeight` here
                setImgHeight(current.clientHeight);
                setImgWidth(current.clientWidth);
                setFlag(true);
                console.log(`Height is ${current.clientHeight}, getHeight calls: ${counterRef.current}, ${current.clientWidth}`);
            }
        };
        getHeightAndWidth();
        return () => {
            cancelled = true;
        };
    }, []);



    const toggleBriefMarker = () => {
        setViewBriefToggle(!viewBriefToggle);
    }


    // const onImgLoad = ({ target: img }) => {
    //     const imageWidth = img.width;
    //     const imageHeight = img.height;
    //     console.log(imageWidth, imageHeight)
    //     setImgWidth(imageWidth);
    //     setImgHeight(imageHeight);
    //     setFlag(true);

    // }

    const handleZoomPanChange = (e) => {
        console.log(e);
        setPositionValueX(e.positionX);
        setPositionValueY(e.positionY);
        setScalingFactor(e.scale);
    }

    const handleMouseMove = (e) => {
        const layerX = e.nativeEvent.layerX;
        const layerY = e.nativeEvent.layerY;
        setX(layerX);
        setY(layerY);
    }

    const handleMouseDown = (e) => {
        const { layerX, layerY } = e.nativeEvent
        newDownX = downX;
        newDownY = downY;
        newDownX = layerX;
        newDownY = layerY;
        console.log(newDownX, newDownY,"downx downy")
        setDownX(newDownX);
        setDownY(newDownY);
        if(scalingFactor === 1){
            setPositionValueX(0);
            setPositionValueY(0);
        }
        var newGroundValueX = (newDownX - (scalingFactor ===1 ? 0:positionValueX)) / scalingFactor;
        var newGroundValueY = (newDownY - (scalingFactor ===1 ? 0 :positionValueY)) / scalingFactor;
        setGroundValueX(newGroundValueX);
        setGroundValueY(newGroundValueY);
        
        var actualScalingFactor = imgHeight / 500;
        console.log(actualScalingFactor,"actual scaling")
        var originalCoordinateX = newGroundValueX * actualScalingFactor;
        var originalCoordinateY = newGroundValueY * actualScalingFactor;
        setOriginalX(originalCoordinateX);
        setOriginalY(originalCoordinateY);

    }

    const modeColor = viewBriefToggle ? "darkblue" : "darkgreen";
    const viewBriefState = viewBriefToggle ? "record markers" : "view markers";
    const primaryPointer = <circle cx={x} cy={y} r={4} fill="black" />
    //   const downPointer = <circle cx={downX / scalingFactor} cy={downY / scalingFactor} r={5} fill="blue" />
    const scaledGridSize = 20;
    var scaledDownImageHeight = 500;
    var actualScalingFactor = imgHeight / scaledDownImageHeight;
    var scaledDownImageWidth = imgWidth / actualScalingFactor;
    // console.log(scaledDownImageWidth)

    const grid = (

        <React.Fragment>
            <defs>
                <pattern id="transformedPattern" x="0" y="0" width={scaledGridSize} height={scaledGridSize} patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width={scaledGridSize} height={scaledGridSize} className="grid-rect" />
                </pattern>
            </defs>
            <rect x="0" y="0" width="100%" height="100%" className="shapes-svg" />
        </React.Fragment>

    );

    const viewMode = viewBriefToggle ?

        <TransformWrapper

            onZoomChange={handleZoomPanChange}
            options={{
                minScale: 1,
                maxScale: 10,
            }}
            onPanning={handleZoomPanChange}

        >
            <React.Fragment>

                <div style={{ width: `${scaledDownImageWidth}px` }}>

                    <TransformComponent >
                        <div style={{ height: '500px' }}>
                            <img src={Map} alt="test" ref={ref} style={flag ? { height: '500px' } : {}} />
                        </div>
                        <div className="sketch-box sketch-stack-top">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={`${scaledDownImageWidth}`}
                                height={`${scaledDownImageHeight}`}
                            >
                            </svg>
                        </div>
                    </TransformComponent>
                </div>
            </React.Fragment>
        </TransformWrapper>
        :
        <TransformWrapper
            onZoomChange={handleZoomPanChange}
            options={{
                minScale: 1,
                maxScale: 10

            }}
        >

            <React.Fragment>

                <div style={{ width: `${scaledDownImageWidth}px` }}>

                    <TransformComponent >
                        <div style={{ height: '500px' }}>
                            <img src={Map} alt="test" ref={ref} style={flag ? { height: '500px' } : {}} />
                        </div>
                        <div className="sketch-box sketch-stack-top">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={`${scaledDownImageWidth}`}
                                height={`${scaledDownImageHeight}`}
                            >
                            </svg>
                        </div>
                    </TransformComponent>
                    <div style={{ width: `${scaledDownImageWidth}px` }} onMouseMove={handleMouseMove} onMouseDown={handleMouseDown}>
                        <div className="sketch-box sketch-stack-top">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={`${scaledDownImageWidth}`}
                                height={`${scaledDownImageHeight}`}
                            >
                                {/* DRAW GRID */}

                                {grid}
                                {primaryPointer}

                            </svg>
                        </div>

                    </div>


                </div>
            </React.Fragment>
        </TransformWrapper>;
    return (

        <React.Fragment>
            <div className="container">
           {viewMode}
            
            <div className="row" >
                <div className="col col-8">
                    <p style={{ fontSize: "15px", fontWeight: "bold", color: `${viewBriefToggle ? "darkgreen" : "darkblue"}`, textAlign: "end" }}>
                        {viewBriefToggle ? "In view mode 👁" : "In recording mode ⬤"} | Mouse coordinates: {x}, {y} | Clicked: {downX}, {downY}
                    </p>
                    <p style={{ fontSize: "15px", fontWeight: "bold", color: `${viewBriefToggle ? "darkgreen" : "darkblue"}`, textAlign: "end" }}>
                        {viewBriefToggle ? "In view mode 👁" : "In recording mode ⬤"} | Ground coordinates clicked: {groundValueX}, {groundValueY} | Orginal coordinates: {originalX}, {originalY}
                    </p>
                </div>
                <div className="col col-4">
                    <span className="badge ml-2" style={{ backgroundColor: `${modeColor}`, color: "whitesmoke" }} role="button" onClick={() => { toggleBriefMarker() }}>switch to {viewBriefState}</span>
                </div>
            </div>
</div>

        </React.Fragment>

    )
}

export default ZoomPanPinch